import Evee from 'evee';
import Vue from 'vue';

const EveeEventBus = new Evee();
var __emit = EveeEventBus.emit.bind(EveeEventBus);
EveeEventBus.emit = (target, data) => {
    console.log('Event fired:', {
        target: target,
        data: data
    });
    __emit(target, data);
};


class CustomEventBus {
    constructor() {
        this.vue = new Vue();
    }

    on(target, callback) {
        this.vue.$on(target, (data) => callback({
            data: data
        }));
    }

    emit(target, data) {
        this.vue.$emit(target, data);
    }
}


export default new CustomEventBus();



// WEBPACK FOOTER //
// ./src/EventBus.js